import { ConfigurationField } from './Field';
import { ConfigurationAction } from './Action';
import { ConfigurationSectionTypeEnum } from '@/enums/ConfigurationSectionTypeEnums';
import { ConfigurationValueSelect } from './ValuesSelect';

export interface IConfigurationSection {
    /**
     * Name of the section
     */
    name: string;
    /**
     * Postion of the section inside the array
     */
    position: number;
    /**
     * A list of optional sub fields
     */
    fields: ConfigurationField[];
    /**
     * If the section is an action field this property is set
     */
    action?: ConfigurationAction;
    /**
     * A list of values, e.g. for select fields
     */
    values?: ConfigurationValueSelect[];
    /**
     * The uniqe identifier string of the section
     */
    identifier: string;
    /**
     * The section type
     */
    type: ConfigurationSectionTypeEnum;
    /**
     * If it is a section from units this is the base unit index
     */
    base?: number;
}

export interface IConfigurationSectionMethods {
    /**
     * Method to check if all fields of section are valid
     */
    isValidSection(): boolean;

    /**
     * Method to get number of fields that have a value set,
     */
    getSetValuesCounter(): number;
}

export class ConfigurationSection implements IConfigurationSection, IConfigurationSectionMethods {
    public name: string;
    public position: number;
    public identifier: string;
    public type: ConfigurationSectionTypeEnum;

    public fields: ConfigurationField[];
    public action?: ConfigurationAction;
    public values?: ConfigurationValueSelect[];
    public base?: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationSection);
    constructor(obj?: any) {
        this.name = (obj && obj.name) || '';
        this.position = (obj && obj.position) || 0;
        this.identifier = (obj && obj.identifier) || '';
        this.type = obj && obj.type != null ? obj.type : ConfigurationSectionTypeEnum.GENERAL;

        if (obj && obj.action !== undefined) {
            this.action = new ConfigurationAction(obj.action);
        }

        this.fields = [];
        if (obj && obj.fields !== undefined) {
            obj.fields.forEach((field: ConfigurationField) => {
                this.fields.push(new ConfigurationField(field));
            });
        }

        if (obj && obj.values !== undefined) {
            this.values = [];
            obj.values.forEach((value: ConfigurationValueSelect) => {
                this.values!.push(new ConfigurationValueSelect(value));
            });
        }

        if (obj && obj.base != null) {
            this.base = obj.base;
        }
    }

    public isValidSection(): boolean {
        let valid: boolean = true;

        if (this.fields && this.fields.length > 0) {
            for (const field of this.fields) {
                if (field.isValidField() === false) {
                    valid = false;
                    break;
                }
            }
        } else {
            // TODO: check if it's working with not rendered parts?
            valid = false;
        }
        return valid;
    }

    public getSetValuesCounter(): number {
        let setValueCount = 0;
        if (this.fields != null) {
            for (const field of this.fields) {
                setValueCount += field.getSetValuesCounter();
            }
        }
        return setValueCount;
    }
}
